import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, Grape } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b border-gray-100" data-id="element-301">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302">
        <div className="flex justify-between items-center h-20" data-id="element-303">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => navigate('/')} data-id="element-304">

            <div className="bg-violet-100 p-2 rounded-lg mr-2" data-id="element-305">
              <Grape className="h-6 w-6 text-violet-600" data-id="element-306" />
            </div>
            <span className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-307">
              Berry Finance
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-308">
            <a href="#features" className="text-gray-600 hover:text-violet-600 font-medium transition-colors" data-id="element-309">

              Features
            </a>
            <a href="#how-it-works" className="text-gray-600 hover:text-violet-600 font-medium transition-colors" data-id="element-310">

              How It Works
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-violet-600 font-medium transition-colors" data-id="element-311">

              Pricing
            </a>
            {/* <a
             href="#"
             className="text-gray-600 hover:text-violet-600 font-medium transition-colors">
              
             </a> */}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-312">
            {/* <a
             href="#"
             className="text-gray-900 font-medium hover:text-violet-600 transition-colors">
              Sign in
             </a> */}
            <Button variant="primary" size="sm" data-id="element-313">
              
              <a href="https://tally.so/r/D4dgqb" target="_blank" rel="noopener noreferrer" data-id="element-314">
              
              Try Berry for Free
            </a> 
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-315">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-500 hover:text-gray-700 focus:outline-none p-2" data-id="element-316">

              {isMenuOpen ? <X className="h-6 w-6" data-id="element-317" /> : <Menu className="h-6 w-6" data-id="element-318" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-b border-gray-100 shadow-lg absolute w-full" data-id="element-319">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-320">
            <a href="#features" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-violet-600 hover:bg-violet-50" data-id="element-321">

              Features
            </a>
            <a href="#how-it-works" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-violet-600 hover:bg-violet-50" data-id="element-322">

              How It Works
            </a>
            <a href="#pricing" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-violet-600 hover:bg-violet-50" data-id="element-323">

              Pricing
            </a>
          
            <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-324">
              {/* <a
               href="#"
               className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50">
                 Sign in
               </a> */}
              <div className="px-3 py-2" data-id="element-325">
                <Button fullWidth onClick={() => {
              setIsMenuOpen(false);
              // navigate('/connect');
            }} data-id="element-326">

                  <a href="https://tally.so/r/D4dgqb" target="_blank" rel="noopener noreferrer" data-id="element-327">
                    
                    Try Berry for Free
                  </a> 
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </nav>;
}